import { writable } from 'svelte/store';

const savedUser = JSON.parse(localStorage.getItem("TciSavedUser"));
const savedUserPreferences = JSON.parse(localStorage.getItem("TciSavedUserPreferences"));

const savedCreateUser = JSON.parse(localStorage.getItem("TciSavedCreateUser"));
const savedCreateAccount = JSON.parse(localStorage.getItem("TciSavedCreateAccount"));

const savedIsApiRefetched = JSON.parse(localStorage.getItem("TciSavedIsApiRefetched"));

const LoggedInDoctorDetail = JSON.parse(localStorage.getItem("LoggedInDoctorDetail"));

export let storeDocumentBankTransfer = writable({});
export let storeDocumentBankTransferForInvestment = writable({});
export let idIncrement = writable({});
export let idIncrementForInvestment = writable({});
export let isMobile = writable(Boolean);
export let isMobileDevice = writable(Boolean);

export const user = writable({
    token: savedUser ? savedUser.token : null,
    refreshToken: savedUser ? savedUser.refreshToken : null,
    expiration: savedUser ? savedUser.expiration : null,
    name: savedUser ? savedUser.name : null,
    role: savedUser ? savedUser.role : null,
    id: savedUser ? savedUser.id : null,
    uniqueId: savedUser ? savedUser.uniqueId : null,
    calendarColour: savedUser ? savedUser.calendarColour : null,
    settings: savedUser ? savedUser.settings : {},
    groupId: savedUser ? savedUser.groupId : null,
    groupName: savedUser ? savedUser.groupName : null,
    defaultFilters: savedUser ? savedUser.defaultFilters ?? null : null,
    email: savedUser ? savedUser.email : null,
    envSettings: savedUser ? savedUser.envSettings ?? {} : {},
});
 
export const createUser = writable({
    token: savedCreateUser ? savedCreateUser.token : null,
    refreshToken: savedCreateUser ? savedCreateUser.refreshToken : null,
    expiration: savedCreateUser ? savedCreateUser.expiration : null,
    id: savedCreateUser ? savedCreateUser.id : null,
    name: savedCreateUser ? savedCreateUser.name : null,
    role: savedCreateUser ? savedCreateUser.role : null,
    email: savedCreateUser ? savedCreateUser.email : null,
    phone: savedCreateUser ? savedCreateUser.phone : null,
    pwd: savedCreateUser ? savedCreateUser.pwd : null
})

export const createAccount = writable({})

export const userLoginDetails = writable({});

export const userPreferences = writable({
    savedUserEmail: savedUserPreferences ? savedUserPreferences.savedUserEmail : null,
    isSidebarExpanded: savedUserPreferences ? savedUserPreferences.isSidebarExpanded : null,
})

export const isRetriedFetch = writable(savedIsApiRefetched ? savedIsApiRefetched : false);

user.subscribe(value => {
    localStorage.setItem("TciSavedUser", JSON.stringify(value));
});

createUser.subscribe(value => {
    localStorage.setItem("TciSavedCreateUser", JSON.stringify(value));
});

createAccount.subscribe(value => {
    localStorage.setItem("TciSavedCreateAccount", JSON.stringify(value))
})

userPreferences.subscribe(value => {
    localStorage.setItem("TciSavedUserPreferences", JSON.stringify(value));
});

isRetriedFetch.subscribe(value => localStorage.setItem("TciSavedIsApiRefetched", JSON.stringify(value)));

export const preventRedirect = writable(false);

export const preventRedirectObj = writable({});

export const loggedInDoctorDetail = writable(LoggedInDoctorDetail ?? {});

loggedInDoctorDetail.subscribe(value => {
    localStorage.setItem("LoggedInDoctorDetail", JSON.stringify(value))
})

export const insuranceFund = writable([]);

export const accounts = writable([]);

export const accountDoctors = writable([]);

export const workersCompensation = writable([]);

export const trafficAccidentAuthorities = writable([]);

export const selectedPaymentCsvFile = writable({});

export const selectedAccountSchedulePdf = writable({});

export const providersSpecialityCodes = writable([]);

export const mbsItemsLogic = writable([]);

export const asaItemsLogic = writable([]);

export const mbsToAsaDisallowAsaByInsuranceType = writable([]);

export const mbsToAsaDisallowInsuranceTypeByState = writable({})

export const amaUnitValue = writable(Number(0))

export const noPatientClaimFunds = writable([])

export const mbsAllItemsList = writable([]);

export const asaAllItemsList = writable([]);

export const ShowErrorModal = writable(false);

export const ErrorDetail = writable();

export const ErrorModalCloseFunction = writable(() => { });

export const bupaPractices = writable([]);

export const allGroups = writable([]);

export const ShowInfoModal = writable(false);

export const InfoDetail = writable();

export const showImagePreviewModal = writable(false);

export const previewImageObj = writable({});

export const showApiErrorModal = writable(false);

export const showServerDisconnectionModal = writable(false);

export const serverDisconnectionReason = writable("");

export const firstFetchErrorMsg = writable("");

export const LastListUrl = writable("");

export const isUserStayOnTab = writable(true);

export const CalendarEventCategories = writable([]);

export const EncounterSidePanelProps = writable({
    id: null,
    type: "",
    shouldTriggerCloseFunction: false,
    onCloseFunction: () => {},
});

export const EmailTypes = writable([]);

export const SMSTypes = writable([]);

export const PDFTypes = writable([]);

export const defaultFilters = writable({})

export const IsLoadingCalendarEventCategories = writable(false);

export const prePopulateAccountOptions = writable([]);

export const dailyPlannerHourLabelWidth = writable(0);

export const savedPublicHolidays = writable({});

export const showViewLogModal = writable(false);

export const viewLogDetails = writable({});

export const preOpQuestionnaires = writable([]);

export const preOpInstructions = writable([]);

export const postOpSurveys = writable([]);

export const showGlobalNotificationModal = writable(false);

export const globalNotificationModalDetails = writable({});

export const showCommunicationConfirmationModal = writable(false);

export const communicationConfirmationModalDetails = writable({
    encounterDetails: null,
    onProceed: null,
});

export const showConfirmActionModal = writable(false);

export const confirmActionModalDetails = writable({
    title: "Confirmation",
    message: "",
    actions: [],
    modalMaxWidth: "",
});

export const tableScrollPosition = writable({});

export const wcEncounterIdFullDetails = writable([]);

export const tacEncounterIdFullDetails = writable([]);
